<template>
  <div>
    <van-overlay :show="show" z-index=999 class="jloading">
      <div class="loadingwrap">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>
<script>

export default {
  name: '',
  components:{

  },
  props:{
    show:false
  },
  data () {
    return {
      
    }
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>
.jloading{
  display: flex;
  align-items: center;
  justify-items: center;
}
.loadingwrap{
  text-align: center;
  flex: auto;
}
</style>